var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExecutionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vertical_split-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.063,
    height: 84.063,
    viewBox: "0 0 84.063 84.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2745",
    d: "M0,0H84.063V84.063H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2746",
    d: "M6.5,40.026H27.518a3.5,3.5,0,1,0,0-7.005H6.5a3.5,3.5,0,0,0,0,7.005Zm0,14.01H27.518a3.5,3.5,0,1,0,0-7.005H6.5a3.5,3.5,0,0,0,0,7.005Zm0-28.021H27.518a3.5,3.5,0,1,0,0-7.005H6.5a3.5,3.5,0,0,0,0,7.005ZM3,8.5a3.513,3.513,0,0,0,3.5,3.5H27.518a3.5,3.5,0,1,0,0-7.005H6.5A3.513,3.513,0,0,0,3,8.5ZM41.529,5H62.544a3.513,3.513,0,0,1,3.5,3.5V50.534a3.513,3.513,0,0,1-3.5,3.5H41.529a3.513,3.513,0,0,1-3.5-3.5V8.5A3.513,3.513,0,0,1,41.529,5Z",
    transform: "translate(7.508 12.513)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutionIcon);
export default __webpack_public_path__ + "static/media/executionIcon.5641328e.svg";
export { ForwardRef as ReactComponent };